// extracted by mini-css-extract-plugin
export var auto = "_4n-1";
export var spinner = "_4n-0";